module.exports = __webpack_public_path__ + "static/media/stars-graphic.e61c6212.png";